/**
 * `@skaile/workspaces/deploy` — built-in deploy targets + the detach-handle store.
 *
 * Ships the three loopback-only built-ins (local, docker, podman),
 * `registerBuiltinDeployTargets()` to load them into a `PluginRegistry`, and the
 * `.skaile/deploy/handle.json` read/write/restore API. Cloud targets (fly,
 * vercel-sandbox, k8s) ship as separate packages that self-register.
 */

import { type PluginRegistry, pluginRegistry } from "@skaile/workspaces/plugin-registry";
import { dockerDeployTarget } from "./targets/docker.js";
import { localDeployTarget } from "./targets/local.js";
import { nixDeployTarget } from "./targets/nix.js";
import { podmanDeployTarget } from "./targets/podman.js";

export {
  clearHandle,
  handlePath,
  readHandle,
  type StoredHandle,
  writeHandle,
} from "./handle-store.js";
export { makeContainerDeployTarget } from "./targets/container-runtime.js";
export { dockerDeployTarget } from "./targets/docker.js";
export { localDeployTarget } from "./targets/local.js";
export { buildNixArgs, nixDeployTarget } from "./targets/nix.js";
export { podmanDeployTarget } from "./targets/podman.js";

/**
 * Register the built-in deploy targets into `registry` (the process-wide
 * `pluginRegistry` by default). Idempotent — an id already present is skipped,
 * so calling this from multiple CLI entrypoints is safe.
 */
export function registerBuiltinDeployTargets(registry: PluginRegistry = pluginRegistry): void {
  for (const t of [localDeployTarget, dockerDeployTarget, podmanDeployTarget, nixDeployTarget]) {
    if (!registry.get("deployTarget", t.id)) registry.register("deployTarget", t);
  }
}
